import { render, staticRenderFns } from "./ActiveSharedUser.vue?vue&type=template&id=1e5c6a44"
import script from "./ActiveSharedUser.vue?vue&type=script&lang=js"
export * from "./ActiveSharedUser.vue?vue&type=script&lang=js"
import style0 from "./ActiveSharedUser.vue?vue&type=style&index=0&id=1e5c6a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports